import { ApplicationEnum } from "../../enums/ApplicationEnum";
import { GroupedAgencies } from "../../resources-vue/vue-models/agency";

export const getSolutionAgencyIds = (
    agencies: Map<string, GroupedAgencies>,
    applicationIds: Set<ApplicationEnum>
): string[] => {
    if (agencies.size < 1) return [];
    const agencyIds: string[] = [];
    for (const [, value] of agencies) {
        for (const item of value.data || []) {
            if (applicationIds.has(item.Application)) {
                if (item.AgencyId && !agencyIds.includes(item.AgencyId)) {
                    agencyIds.push(item.AgencyId);
                }
            }
        }
    }
    return agencyIds;
};
